import type { ConversionRatesOverviewListParams } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";
import { parseConversionRateError } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";

export const useConversionRateData = (params: ConversionRatesOverviewListParams, { enabled }: { enabled: boolean }) => {
    const queryResult = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesOverviewList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );

    const emptyStateType = queryResult.isError ? parseConversionRateError(queryResult.error) : null;

    return {
        data: queryResult.data,
        isLoading: queryResult.isLoading,
        isError: queryResult.isError,
        emptyStateType,
    };
};
